import axios from 'axios';
import moment from 'moment-timezone';
import { isClient } from '../../../../utils/appUtils';
import { JOB_LIST } from '../../../constants';

export const fetchJobList = (data, category, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadJobList());

  data.currentDate = moment().format('YYYY-MM-DD');
  data.timeZone = moment.tz.guess();

  axios
    .post(
      isClient() ? `/client/listJobs` : `/jobs/listJobs`,
      data,
      config,
    )
    .then((res) => dispatch(setJobList(res.data.data)))
    .catch((err) => {
      dispatch(errorJobList(err.response));
      onError(err.response);
    });
};

export const loadJobList = () => ({
  type: JOB_LIST.LOAD,
});

export const setJobList = (jobList) => ({
  type: JOB_LIST.SUCCESS,
  payload: jobList,
});

export const errorJobList = (error) => ({
  type: JOB_LIST.FAIL,
  payload: error,
});
